import React, { useState } from "react";
import {
  FormControl,
  MenuItem,
  Menu,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { Group, KeyboardArrowDown } from "@mui/icons-material";
import { PlatformOptions } from "../utils/Contants";
import muiStyles from "../styles/muiStyles";
import { useTranslation } from "react-i18next";

const DropdownPlatform = ({
  platform,
  changePlatform,
  existingPlatforms = [],
  disabled,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (type) => {
    changePlatform(type);
    handleClose();
  };

  const { t } = useTranslation("components");

  const selectedPlatform = PlatformOptions.find(
    (item) => item.value.toLowerCase() === platform?.type?.toLowerCase()
  );

  const isPlatformUsed = (platformType) => {
    return existingPlatforms.some(
      (existingPlatform) =>
        existingPlatform.type.toLowerCase() === platformType.toLowerCase()
    );
  };

  return (
    <FormControl sx={{ minWidth: 150 }}>
      <Button
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="outlined"
        size="small"
        disabled={disabled}
        sx={{
          justifyContent: "space-between",
          textTransform: "none",
          borderRadius: "8px",
          height: "39px",
          borderColor: "#e0e0e0",
          color: "rgba(47, 43, 61, 0.9)",
          "&:hover": {
            borderColor: "#257c6d",
            backgroundColor: "rgba(37, 124, 109, 0.04)",
          },
          "&.Mui-disabled": {
            backgroundColor: "rgba(248, 247, 250, 1)",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {selectedPlatform?.iconPath ? (
            <img
              src={selectedPlatform?.iconPath}
              alt="icon"
              style={{ ...muiStyles.socialIconStyles }}
            />
          ) : (
            <Group />
          )}
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 400,
              textTransform: "capitalize",
            }}
          >
            {t("social." + selectedPlatform?.text) ||
              t("social.select_platform")}
          </Typography>
        </Box>
        <KeyboardArrowDown />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `platform-button`,
        }}
        PaperProps={{
          style: {
            marginTop: "12px",
            borderRadius: "12px",
            padding: "12px",
            minWidth: "182px",
          },
        }}
      >
        {PlatformOptions.map((option, idx) => {
          const isUsed = isPlatformUsed(option.value);
          const isCurrentlySelected =
            platform?.type?.toLowerCase() === option.value.toLowerCase();

          return (
            <MenuItem
              key={option.value}
              onClick={() => handleMenuItemClick(option.value)}
              selected={isCurrentlySelected}
              disabled={isUsed && !isCurrentlySelected}
              sx={{
                mb: idx !== PlatformOptions.length - 1 ? "12px" : 0,
                padding: "8px 12px",
                borderRadius: "4px",
                "&.Mui-selected": {
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                  },
                },
                "&.Mui-disabled": {
                  opacity: 0.5,
                  cursor: "not-allowed",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <img
                  src={option.iconPath}
                  alt="icon"
                  style={{
                    ...muiStyles.socialIconStyles,
                    opacity: isUsed && !isCurrentlySelected ? 0.5 : 1,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 400,
                    opacity: isUsed && !isCurrentlySelected ? 0.5 : 1,
                  }}
                >
                  {t("social." + option.text)}
                </Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Menu>
    </FormControl>
  );
};

export default DropdownPlatform;
